import { MapContainer, TileLayer, CircleMarker, Popup } from "react-leaflet";
import { Link } from "react-router-dom";

const colorFor = (status) => {
  if (status === "lead_free_required") return "#2D5A4C";
  if (status === "biodegradable_required") return "#C95B3B";
  if (status === "no_restrictions") return "#8A8D86";
  return "#D99A29";
};

const typeLabel = (t) => {
  if (t === "wildlife_refuge") return "NW Refuge";
  if (t === "national_park") return "National Park";
  return "Fishing Site";
};

export const ParkMap = ({ parks }) => {
  return (
    <div className="w-full h-[520px] border border-border" data-testid="parks-map">
      <MapContainer center={[41.5, -85]} zoom={4} scrollWheelZoom={false} style={{ height: "100%", width: "100%" }}>
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        {parks.map((p) => (
          <CircleMarker
            key={p.id}
            center={[p.lat, p.lng]}
            radius={10}
            pathOptions={{ color: colorFor(p.regulation_status), fillColor: colorFor(p.regulation_status), fillOpacity: 0.75, weight: 2 }}
          >
            <Popup>
              <div className="min-w-[220px]">
                <div className="label-eyebrow mb-1" style={{ color: colorFor(p.regulation_status) }}>
                  {typeLabel(p.type)}
                </div>
                <div className="font-display text-lg leading-tight mb-1">{p.name}</div>
                <div className="text-xs text-muted-foreground mb-2">{p.state}</div>
                <p className="text-sm mb-2">{p.summary}</p>
                {p.effective_date && (
                  <div className="text-xs mb-2">
                    <span className="label-eyebrow">Effective</span>{" "}
                    <span className="font-semibold">{p.effective_date}</span>
                  </div>
                )}
                <Link to={`/parks/${p.slug}`} className="text-sm text-[#C95B3B] hover:underline font-medium">
                  View details →
                </Link>
              </div>
            </Popup>
          </CircleMarker>
        ))}
      </MapContainer>
    </div>
  );
};
